// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskNotificationToasts-module__font-s-10___AxNbA {
  font-size: 10px !important;
}

.TaskNotificationToasts-module__font-s-12___dDcMI {
  font-size: 12px !important;
}

.TaskNotificationToasts-module__font-s-13___YYEkp {
  font-size: 13px !important;
}

.TaskNotificationToasts-module__font-s-14___um2bh {
  font-size: 14px !important;
}

.TaskNotificationToasts-module__font-s-15___M2T_x {
  font-size: 15px !important;
}

.TaskNotificationToasts-module__font-s-16___pfbLv {
  font-size: 16px !important;
}

.TaskNotificationToasts-module__font-s-18___khru4 {
  font-size: 18px !important;
}

.TaskNotificationToasts-module__font-s-20___yNBNj {
  font-size: 20px !important;
}

.TaskNotificationToasts-module__font-s-22___j6LdF {
  font-size: 22px !important;
}

.TaskNotificationToasts-module__font-s-28___tAWRe {
  font-size: 28px !important;
}

.TaskNotificationToasts-module__font-w-400___XNYBs {
  font-weight: 400 !important;
}

.TaskNotificationToasts-module__font-w-500___fMRfK {
  font-weight: 500 !important;
}

.TaskNotificationToasts-module__font-w-600____Y3fR {
  font-weight: 600 !important;
}

.TaskNotificationToasts-module__font-w-700___fdMO1 {
  font-weight: 700 !important;
}

.TaskNotificationToasts-module__p-5___oXd6q {
  padding: 5px !important;
}

.TaskNotificationToasts-module__p-12___P5l9P {
  padding: 12px !important;
}

.TaskNotificationToasts-module__p-16___cT87w {
  padding: 16px !important;
}

.TaskNotificationToasts-module__p-30___OQcA3 {
  padding: 30px !important;
}

.TaskNotificationToasts-module__p-b-0___UcmjP {
  padding-bottom: 0 !important;
}

.TaskNotificationToasts-module__p-b-5___yYD5s {
  padding-bottom: 5px !important;
}

.TaskNotificationToasts-module__p-b-10___tiZYE {
  padding-bottom: 10px !important;
}

.TaskNotificationToasts-module__p-b-12___pvVwC {
  padding-bottom: 12px !important;
}

.TaskNotificationToasts-module__p-b-16___VRxkv {
  padding-bottom: 16px !important;
}

.TaskNotificationToasts-module__p-b-18___mpwVF {
  padding-bottom: 18px !important;
}

.TaskNotificationToasts-module__p-b-20___MedpU {
  padding-bottom: 20px !important;
}

.TaskNotificationToasts-module__p-b-25___hkzL5 {
  padding-bottom: 25px !important;
}

.TaskNotificationToasts-module__p-b-30___bvqne {
  padding-bottom: 30px !important;
}

.TaskNotificationToasts-module__p-b-50___BwWoV {
  padding-bottom: 50px !important;
}

.TaskNotificationToasts-module__p-t-0___WFBXk {
  padding-top: 0 !important;
}

.TaskNotificationToasts-module__p-t-12___MyE0M {
  padding-top: 12px !important;
}

.TaskNotificationToasts-module__p-t-16___dXdCK {
  padding-top: 16px !important;
}

.TaskNotificationToasts-module__p-t-18___D8UIW {
  padding-top: 18px !important;
}

.TaskNotificationToasts-module__p-t-20____RiVK {
  padding-top: 20px !important;
}

.TaskNotificationToasts-module__p-t-30___qzSTS {
  padding-top: 30px !important;
}

.TaskNotificationToasts-module__p-t-40___KAHw7 {
  padding-top: 40px !important;
}

.TaskNotificationToasts-module__p-t-50___yqV52 {
  padding-top: 50px !important;
}

.TaskNotificationToasts-module__p-l-20___PGKVl {
  padding-left: 20px !important;
}

.TaskNotificationToasts-module__p-l-30___UWWqZ {
  padding-left: 30px !important;
}

.TaskNotificationToasts-module__p-l-40___acEnx {
  padding-left: 40px !important;
}

.TaskNotificationToasts-module__p-r-16___eAasF {
  padding-right: 16px !important;
}

.TaskNotificationToasts-module__p-r-20___IXHud {
  padding-right: 20px !important;
}

.TaskNotificationToasts-module__p-r-30___kn6fD {
  padding-right: 30px !important;
}

.TaskNotificationToasts-module__p-r-50___QGgjj {
  padding-right: 50px !important;
}

.TaskNotificationToasts-module__p-r-60___sBWUS {
  padding-right: 60px !important;
}

.TaskNotificationToasts-module__m-b-1___ML3tP {
  margin-bottom: 1px !important;
}

.TaskNotificationToasts-module__m-b-2___wWaiL {
  margin-bottom: 2px !important;
}

.TaskNotificationToasts-module__m-b-6___xwrYT {
  margin-bottom: 6px !important;
}

.TaskNotificationToasts-module__m-b-8___OB7j9 {
  margin-bottom: 8px !important;
}

.TaskNotificationToasts-module__m-b-10___tJ_pR {
  margin-bottom: 10px !important;
}

.TaskNotificationToasts-module__m-b-14___GlLfw {
  margin-bottom: 14px !important;
}

.TaskNotificationToasts-module__m-b-16___qXZE0 {
  margin-bottom: 16px !important;
}

.TaskNotificationToasts-module__m-b-20___QTgox {
  margin-bottom: 20px !important;
}

.TaskNotificationToasts-module__m-b-22___iMxEc {
  margin-bottom: 22px !important;
}

.TaskNotificationToasts-module__m-b-24___JixMo {
  margin-bottom: 24px !important;
}

.TaskNotificationToasts-module__m-b-30___CK5_1 {
  margin-bottom: 30px !important;
}

.TaskNotificationToasts-module__m-b-32___QcdSf {
  margin-bottom: 32px !important;
}

.TaskNotificationToasts-module__m-b-40___XmLNz {
  margin-bottom: 40px !important;
}

.TaskNotificationToasts-module__m-t-2___TCEgD {
  margin-top: 2px !important;
}

.TaskNotificationToasts-module__m-t-3___uWu1H {
  margin-top: 3px !important;
}

.TaskNotificationToasts-module__m-t-4___Kr2hL {
  margin-top: 4px !important;
}

.TaskNotificationToasts-module__m-t-5___VKS9l {
  margin-top: 5px !important;
}

.TaskNotificationToasts-module__m-t-8___wFJOO {
  margin-top: 8px !important;
}

.TaskNotificationToasts-module__m-t-10___LKZ1E {
  margin-top: 10px !important;
}

.TaskNotificationToasts-module__m-t-15___DPHII {
  margin-top: 15px !important;
}

.TaskNotificationToasts-module__m-t-16___quYwA {
  margin-top: 16px !important;
}

.TaskNotificationToasts-module__m-t-20___My11H {
  margin-top: 20px !important;
}

.TaskNotificationToasts-module__m-t-22___uonB_ {
  margin-top: 22px !important;
}

.TaskNotificationToasts-module__m-t-30___pQMxe {
  margin-top: 30px !important;
}

.TaskNotificationToasts-module__m-t-32___iHDXg {
  margin-top: 32px !important;
}

.TaskNotificationToasts-module__m-l-auto___DuitN {
  margin-left: auto !important;
}

.TaskNotificationToasts-module__m-l-4___T40hY {
  margin-left: 4px !important;
}

.TaskNotificationToasts-module__m-l-5___ziHFz {
  margin-left: 5px !important;
}

.TaskNotificationToasts-module__m-l-6___khI17 {
  margin-left: 6px !important;
}

.TaskNotificationToasts-module__m-l-8____PwUH {
  margin-left: 8px !important;
}

.TaskNotificationToasts-module__m-l-10___0No8S {
  margin-left: 10px !important;
}

.TaskNotificationToasts-module__m-l-16___d8_9E {
  margin-left: 16px !important;
}

.TaskNotificationToasts-module__m-l-20___AnTUI {
  margin-left: 20px !important;
}

.TaskNotificationToasts-module__m-l-24___JMrP0 {
  margin-left: 24px !important;
}

.TaskNotificationToasts-module__m-l-30___uhsmC {
  margin-left: 30px !important;
}

.TaskNotificationToasts-module__m-l-35___pEYb_ {
  margin-left: 35px !important;
}

.TaskNotificationToasts-module__m-l-40___NNBbA {
  margin-left: 40px !important;
}

.TaskNotificationToasts-module__m-r-8___cBOjW {
  margin-right: 8px !important;
}

.TaskNotificationToasts-module__m-r-10___UmWYZ {
  margin-right: 10px !important;
}

.TaskNotificationToasts-module__m-r-16___gPyrW {
  margin-right: 16px !important;
}

.TaskNotificationToasts-module__m-r-20___wfoMG {
  margin-right: 20px !important;
}

.TaskNotificationToasts-module__m-r-24___FLzN2 {
  margin-right: 24px !important;
}

.TaskNotificationToasts-module__m-r-30___EucLx {
  margin-right: 30px !important;
}

.TaskNotificationToasts-module__m-r-40___ft9ip {
  margin-right: 40px !important;
}

.TaskNotificationToasts-module__border-r-3___kzkWt {
  border-radius: 3px !important;
}

.TaskNotificationToasts-module__border-r-4___WNQbK {
  border-radius: 4px !important;
}

.TaskNotificationToasts-module__border-r-6___PP0wF {
  border-radius: 6px !important;
}

.TaskNotificationToasts-module__border-r-10___CfbzH {
  border-radius: 10px !important;
}

.TaskNotificationToasts-module__border-r-12___U6A6j {
  border-radius: 12px !important;
}

.TaskNotificationToasts-module__border-r-16___MHHO5 {
  border-radius: 16px !important;
}

.TaskNotificationToasts-module__border-r-50___RAu1x {
  border-radius: 50% !important;
}

.TaskNotificationToasts-module__primary-border___raq9C {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskNotificationToasts-module__primary-border-b___gQ6RC {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskNotificationToasts-module__primary-border-t___ahZ45 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskNotificationToasts-module__primary-border-l___KD5Cm {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskNotificationToasts-module__primary-border-r___KKt5p {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskNotificationToasts-module__secondary-border___Rbna7 {
  border: 1px solid #637768;
}

.TaskNotificationToasts-module__secondary-border-b___Cz1lK {
  border-bottom: 1px solid #637768;
}

.TaskNotificationToasts-module__secondary-border-t___nkMYr {
  border-top: 1px solid #637768;
}

.TaskNotificationToasts-module__secondary-border-l___hyHkh {
  border-left: 1px solid #637768;
}

.TaskNotificationToasts-module__secondary-border-r___eq1Qn {
  border-right: 1px solid #637768;
}

.TaskNotificationToasts-module__gap-0___xptem {
  gap: 0 !important;
}

.TaskNotificationToasts-module__gap-2___dLl8l {
  gap: 2px !important;
}

.TaskNotificationToasts-module__gap-4___aXRV9 {
  gap: 4px !important;
}

.TaskNotificationToasts-module__gap-5___za_ua {
  gap: 5px !important;
}

.TaskNotificationToasts-module__gap-6___ohEbM {
  gap: 6px !important;
}

.TaskNotificationToasts-module__gap-8___oMq7p {
  gap: 8px !important;
}

.TaskNotificationToasts-module__gap-10___MMOvW {
  gap: 10px !important;
}

.TaskNotificationToasts-module__gap-12___Lyy5w {
  gap: 12px !important;
}

.TaskNotificationToasts-module__gap-14___dEnnc {
  gap: 14px !important;
}

.TaskNotificationToasts-module__gap-16___f0aGi {
  gap: 16px !important;
}

.TaskNotificationToasts-module__gap-18___m6fDs {
  gap: 18px !important;
}

.TaskNotificationToasts-module__gap-20___zPaOL {
  gap: 20px !important;
}

.TaskNotificationToasts-module__gap-24___SCiM5 {
  gap: 24px !important;
}

.TaskNotificationToasts-module__gap-26___y33g9 {
  gap: 26px !important;
}

.TaskNotificationToasts-module__gap-30___TsIda {
  gap: 30px !important;
}

.TaskNotificationToasts-module__gap-32___fMDVY {
  gap: 32px !important;
}

.TaskNotificationToasts-module__gap-40___wV2Ly {
  gap: 40px !important;
}

.TaskNotificationToasts-module__gap-50____ab7L {
  gap: 50px !important;
}

.TaskNotificationToasts-module__flex-1___AbwTZ {
  flex: 1;
}

.TaskNotificationToasts-module__flex-none___exIKL {
  flex: none !important;
}

.TaskNotificationToasts-module__flex-column___f7EcF {
  display: flex;
  flex-direction: column !important;
}

.TaskNotificationToasts-module__flex-row___MGKV4 {
  display: flex;
  flex-direction: row !important;
}

.TaskNotificationToasts-module__vertically-centered___q8Jw2 {
  display: flex;
  align-items: center !important;
}

.TaskNotificationToasts-module__horizontally-centered___CY58I {
  display: flex;
  justify-content: center !important;
}

.TaskNotificationToasts-module__horizontally-end___MwWqG {
  display: flex;
  justify-content: end !important;
}

.TaskNotificationToasts-module__vertically-start___YPGOX {
  display: flex;
  align-items: start !important;
}

.TaskNotificationToasts-module__space-between___XwxHo {
  display: flex;
  justify-content: space-between !important;
}

.TaskNotificationToasts-module__flex-wrap___Bfxzu {
  flex-wrap: wrap !important;
}

.TaskNotificationToasts-module__height-100___ipoVk {
  height: 100%;
}

.TaskNotificationToasts-module__width-50___CyQYW {
  width: 50% !important;
}

.TaskNotificationToasts-module__width-100____AbNA {
  width: 100%;
}

.TaskNotificationToasts-module__cursor-pointer___AZDss {
  cursor: pointer;
}

.TaskNotificationToasts-module__cursor-not-allowed___efGME {
  cursor: not-allowed !important;
}

.TaskNotificationToasts-module__absolute-centered___oNTMN {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TaskNotificationToasts-module__absolute___qaZnl {
  position: absolute;
}

.TaskNotificationToasts-module__relative___QF7fs {
  position: relative;
}

.TaskNotificationToasts-module__fixed___HNN3Y {
  position: fixed;
}

.TaskNotificationToasts-module__visible___EqcyD {
  opacity: 1;
}

.TaskNotificationToasts-module__invisible___kBEK5 {
  opacity: 0;
}

.TaskNotificationToasts-module__col-90___tuU75 {
  width: 90% !important;
}

.TaskNotificationToasts-module__col-auto___OP0Aj {
  width: auto !important;
}

.TaskNotificationToasts-module__medical-tabs___iqnzz {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TaskNotificationToasts-module__medical-table-new___OhIHi {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi::-webkit-scrollbar-track {
  display: none;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi.TaskNotificationToasts-module__no-pagination___oReYU {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi.TaskNotificationToasts-module__no-pagination___oReYU:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi.TaskNotificationToasts-module__no-pagination___oReYU::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TaskNotificationToasts-module__medical-table-new___OhIHi.TaskNotificationToasts-module__no-pagination___oReYU::-webkit-scrollbar-track {
  display: none;
}

.TaskNotificationToasts-module__medical-table-empty___tBHxc {
  padding: 14px 40px !important;
}

.TaskNotificationToasts-module__icon-btn___VvfHc {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TaskNotificationToasts-module__search-icon___NyRY6 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TaskNotificationToasts-module__disable-select___JZ5te {
  user-select: none;
}

.TaskNotificationToasts-module__break-word___mwda0 {
  word-break: break-word;
}

.TaskNotificationToasts-module__popup-clear-btn___BsjXo {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TaskNotificationToasts-module__scroll-m-b-20___j5kkK {
  scroll-margin-bottom: 20px;
}

.TaskNotificationToasts-module__container___riGRp {
  position: fixed;
  right: 20px;
  bottom: 40px;
  z-index: 60;
  width: min(300px, 100vw - 24px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.TaskNotificationToasts-module__toast___Vf9X5 {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  padding: 16px 18px;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.12);
  cursor: pointer;
  font-size: 14px;
  line-height: 1.25;
}

.TaskNotificationToasts-module__toastEntering___ru_Hq {
  animation: TaskNotificationToasts-module__slideUp___t6FbF 0.25s ease-out both;
}

.TaskNotificationToasts-module__toastLeaving___vJgkM {
  animation: TaskNotificationToasts-module__slideDown___D71CN 0.15s ease-in forwards;
}

.TaskNotificationToasts-module__toastCritical___RFD_9 {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.TaskNotificationToasts-module__toastAssignment___rSsk0 {
  background: #ffffff;
  color: #18181b;
  border-color: #e4e4e7;
}

.TaskNotificationToasts-module__toastEscalation___fqbzX {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.TaskNotificationToasts-module__toastFollowedChange___RvIeo {
  background: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.TaskNotificationToasts-module__toastOverdue___bcoBF {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.TaskNotificationToasts-module__toastSubtasksCompleted___ruWvI {
  background: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.TaskNotificationToasts-module__toastSubtaskCanceled___xgete {
  background: #f8fafc;
  color: #334155;
  border-color: #cbd5e1;
}

.TaskNotificationToasts-module__title___y0Tpw {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
}

.TaskNotificationToasts-module__closeButton___yJAgN {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 auto;
  transition: color 0.15s ease;
}

.TaskNotificationToasts-module__closeButton___yJAgN:hover {
  color: #71717a;
}

.TaskNotificationToasts-module__closeIcon___d2PDr {
  width: 14px;
  height: 14px;
}

@keyframes TaskNotificationToasts-module__slideUp___t6FbF {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes TaskNotificationToasts-module__slideDown___D71CN {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(8px);
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/TaskNotificationToasts/TaskNotificationToasts.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AA8pBF;;AA3pBA;EACE,6EAAA;AA8pBF;;AA3pBA;EACE,kFAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE;IACE,UAAA;IACA,2BAAA;EA8pBF;EA3pBA;IACE,UAAA;IACA,wBAAA;EA6pBF;AACF;AA1pBA;EACE;IACE,UAAA;IACA,wBAAA;EA4pBF;EAzpBA;IACE,UAAA;IACA,0BAAA;EA2pBF;AACF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  position: fixed;\n  right: 20px;\n  bottom: 40px;\n  z-index: 60;\n  width: min(300px, calc(100vw - 24px));\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  pointer-events: none;\n}\n\n.toast {\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 64px;\n  padding: 16px 18px;\n  border: 1px solid #e4e4e7;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.12);\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1.25;\n}\n\n.toastEntering {\n  animation: slideUp 0.25s ease-out both;\n}\n\n.toastLeaving {\n  animation: slideDown 0.15s ease-in forwards;\n}\n\n.toastCritical {\n  background: #fef2f2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.toastAssignment {\n  background: #ffffff;\n  color: #18181b;\n  border-color: #e4e4e7;\n}\n\n.toastEscalation {\n  background: #fef2f2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.toastFollowedChange {\n  background: #f0fdf4;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.toastOverdue {\n  background: tone-color(danger, bg);\n  color: tone-color(danger, text);\n  border-color: tone-color(danger, border);\n}\n\n.toastSubtasksCompleted {\n  background: #f0fdf4;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.toastSubtaskCanceled {\n  background: #f8fafc;\n  color: #334155;\n  border-color: #cbd5e1;\n}\n\n.title {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.closeButton {\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex: 0 0 auto;\n  transition: color 0.15s ease;\n}\n\n.closeButton:hover {\n  color: #71717a;\n}\n\n.closeIcon {\n  width: 14px;\n  height: 14px;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TaskNotificationToasts-module__font-s-10___AxNbA`,
	"fontS12": `TaskNotificationToasts-module__font-s-12___dDcMI`,
	"fontS13": `TaskNotificationToasts-module__font-s-13___YYEkp`,
	"fontS14": `TaskNotificationToasts-module__font-s-14___um2bh`,
	"fontS15": `TaskNotificationToasts-module__font-s-15___M2T_x`,
	"fontS16": `TaskNotificationToasts-module__font-s-16___pfbLv`,
	"fontS18": `TaskNotificationToasts-module__font-s-18___khru4`,
	"fontS20": `TaskNotificationToasts-module__font-s-20___yNBNj`,
	"fontS22": `TaskNotificationToasts-module__font-s-22___j6LdF`,
	"fontS28": `TaskNotificationToasts-module__font-s-28___tAWRe`,
	"fontW400": `TaskNotificationToasts-module__font-w-400___XNYBs`,
	"fontW500": `TaskNotificationToasts-module__font-w-500___fMRfK`,
	"fontW600": `TaskNotificationToasts-module__font-w-600____Y3fR`,
	"fontW700": `TaskNotificationToasts-module__font-w-700___fdMO1`,
	"p5": `TaskNotificationToasts-module__p-5___oXd6q`,
	"p12": `TaskNotificationToasts-module__p-12___P5l9P`,
	"p16": `TaskNotificationToasts-module__p-16___cT87w`,
	"p30": `TaskNotificationToasts-module__p-30___OQcA3`,
	"pB0": `TaskNotificationToasts-module__p-b-0___UcmjP`,
	"pB5": `TaskNotificationToasts-module__p-b-5___yYD5s`,
	"pB10": `TaskNotificationToasts-module__p-b-10___tiZYE`,
	"pB12": `TaskNotificationToasts-module__p-b-12___pvVwC`,
	"pB16": `TaskNotificationToasts-module__p-b-16___VRxkv`,
	"pB18": `TaskNotificationToasts-module__p-b-18___mpwVF`,
	"pB20": `TaskNotificationToasts-module__p-b-20___MedpU`,
	"pB25": `TaskNotificationToasts-module__p-b-25___hkzL5`,
	"pB30": `TaskNotificationToasts-module__p-b-30___bvqne`,
	"pB50": `TaskNotificationToasts-module__p-b-50___BwWoV`,
	"pT0": `TaskNotificationToasts-module__p-t-0___WFBXk`,
	"pT12": `TaskNotificationToasts-module__p-t-12___MyE0M`,
	"pT16": `TaskNotificationToasts-module__p-t-16___dXdCK`,
	"pT18": `TaskNotificationToasts-module__p-t-18___D8UIW`,
	"pT20": `TaskNotificationToasts-module__p-t-20____RiVK`,
	"pT30": `TaskNotificationToasts-module__p-t-30___qzSTS`,
	"pT40": `TaskNotificationToasts-module__p-t-40___KAHw7`,
	"pT50": `TaskNotificationToasts-module__p-t-50___yqV52`,
	"pL20": `TaskNotificationToasts-module__p-l-20___PGKVl`,
	"pL30": `TaskNotificationToasts-module__p-l-30___UWWqZ`,
	"pL40": `TaskNotificationToasts-module__p-l-40___acEnx`,
	"pR16": `TaskNotificationToasts-module__p-r-16___eAasF`,
	"pR20": `TaskNotificationToasts-module__p-r-20___IXHud`,
	"pR30": `TaskNotificationToasts-module__p-r-30___kn6fD`,
	"pR50": `TaskNotificationToasts-module__p-r-50___QGgjj`,
	"pR60": `TaskNotificationToasts-module__p-r-60___sBWUS`,
	"mB1": `TaskNotificationToasts-module__m-b-1___ML3tP`,
	"mB2": `TaskNotificationToasts-module__m-b-2___wWaiL`,
	"mB6": `TaskNotificationToasts-module__m-b-6___xwrYT`,
	"mB8": `TaskNotificationToasts-module__m-b-8___OB7j9`,
	"mB10": `TaskNotificationToasts-module__m-b-10___tJ_pR`,
	"mB14": `TaskNotificationToasts-module__m-b-14___GlLfw`,
	"mB16": `TaskNotificationToasts-module__m-b-16___qXZE0`,
	"mB20": `TaskNotificationToasts-module__m-b-20___QTgox`,
	"mB22": `TaskNotificationToasts-module__m-b-22___iMxEc`,
	"mB24": `TaskNotificationToasts-module__m-b-24___JixMo`,
	"mB30": `TaskNotificationToasts-module__m-b-30___CK5_1`,
	"mB32": `TaskNotificationToasts-module__m-b-32___QcdSf`,
	"mB40": `TaskNotificationToasts-module__m-b-40___XmLNz`,
	"mT2": `TaskNotificationToasts-module__m-t-2___TCEgD`,
	"mT3": `TaskNotificationToasts-module__m-t-3___uWu1H`,
	"mT4": `TaskNotificationToasts-module__m-t-4___Kr2hL`,
	"mT5": `TaskNotificationToasts-module__m-t-5___VKS9l`,
	"mT8": `TaskNotificationToasts-module__m-t-8___wFJOO`,
	"mT10": `TaskNotificationToasts-module__m-t-10___LKZ1E`,
	"mT15": `TaskNotificationToasts-module__m-t-15___DPHII`,
	"mT16": `TaskNotificationToasts-module__m-t-16___quYwA`,
	"mT20": `TaskNotificationToasts-module__m-t-20___My11H`,
	"mT22": `TaskNotificationToasts-module__m-t-22___uonB_`,
	"mT30": `TaskNotificationToasts-module__m-t-30___pQMxe`,
	"mT32": `TaskNotificationToasts-module__m-t-32___iHDXg`,
	"mLAuto": `TaskNotificationToasts-module__m-l-auto___DuitN`,
	"mL4": `TaskNotificationToasts-module__m-l-4___T40hY`,
	"mL5": `TaskNotificationToasts-module__m-l-5___ziHFz`,
	"mL6": `TaskNotificationToasts-module__m-l-6___khI17`,
	"mL8": `TaskNotificationToasts-module__m-l-8____PwUH`,
	"mL10": `TaskNotificationToasts-module__m-l-10___0No8S`,
	"mL16": `TaskNotificationToasts-module__m-l-16___d8_9E`,
	"mL20": `TaskNotificationToasts-module__m-l-20___AnTUI`,
	"mL24": `TaskNotificationToasts-module__m-l-24___JMrP0`,
	"mL30": `TaskNotificationToasts-module__m-l-30___uhsmC`,
	"mL35": `TaskNotificationToasts-module__m-l-35___pEYb_`,
	"mL40": `TaskNotificationToasts-module__m-l-40___NNBbA`,
	"mR8": `TaskNotificationToasts-module__m-r-8___cBOjW`,
	"mR10": `TaskNotificationToasts-module__m-r-10___UmWYZ`,
	"mR16": `TaskNotificationToasts-module__m-r-16___gPyrW`,
	"mR20": `TaskNotificationToasts-module__m-r-20___wfoMG`,
	"mR24": `TaskNotificationToasts-module__m-r-24___FLzN2`,
	"mR30": `TaskNotificationToasts-module__m-r-30___EucLx`,
	"mR40": `TaskNotificationToasts-module__m-r-40___ft9ip`,
	"borderR3": `TaskNotificationToasts-module__border-r-3___kzkWt`,
	"borderR4": `TaskNotificationToasts-module__border-r-4___WNQbK`,
	"borderR6": `TaskNotificationToasts-module__border-r-6___PP0wF`,
	"borderR10": `TaskNotificationToasts-module__border-r-10___CfbzH`,
	"borderR12": `TaskNotificationToasts-module__border-r-12___U6A6j`,
	"borderR16": `TaskNotificationToasts-module__border-r-16___MHHO5`,
	"borderR50": `TaskNotificationToasts-module__border-r-50___RAu1x`,
	"primaryBorder": `TaskNotificationToasts-module__primary-border___raq9C`,
	"primaryBorderB": `TaskNotificationToasts-module__primary-border-b___gQ6RC`,
	"primaryBorderT": `TaskNotificationToasts-module__primary-border-t___ahZ45`,
	"primaryBorderL": `TaskNotificationToasts-module__primary-border-l___KD5Cm`,
	"primaryBorderR": `TaskNotificationToasts-module__primary-border-r___KKt5p`,
	"secondaryBorder": `TaskNotificationToasts-module__secondary-border___Rbna7`,
	"secondaryBorderB": `TaskNotificationToasts-module__secondary-border-b___Cz1lK`,
	"secondaryBorderT": `TaskNotificationToasts-module__secondary-border-t___nkMYr`,
	"secondaryBorderL": `TaskNotificationToasts-module__secondary-border-l___hyHkh`,
	"secondaryBorderR": `TaskNotificationToasts-module__secondary-border-r___eq1Qn`,
	"gap0": `TaskNotificationToasts-module__gap-0___xptem`,
	"gap2": `TaskNotificationToasts-module__gap-2___dLl8l`,
	"gap4": `TaskNotificationToasts-module__gap-4___aXRV9`,
	"gap5": `TaskNotificationToasts-module__gap-5___za_ua`,
	"gap6": `TaskNotificationToasts-module__gap-6___ohEbM`,
	"gap8": `TaskNotificationToasts-module__gap-8___oMq7p`,
	"gap10": `TaskNotificationToasts-module__gap-10___MMOvW`,
	"gap12": `TaskNotificationToasts-module__gap-12___Lyy5w`,
	"gap14": `TaskNotificationToasts-module__gap-14___dEnnc`,
	"gap16": `TaskNotificationToasts-module__gap-16___f0aGi`,
	"gap18": `TaskNotificationToasts-module__gap-18___m6fDs`,
	"gap20": `TaskNotificationToasts-module__gap-20___zPaOL`,
	"gap24": `TaskNotificationToasts-module__gap-24___SCiM5`,
	"gap26": `TaskNotificationToasts-module__gap-26___y33g9`,
	"gap30": `TaskNotificationToasts-module__gap-30___TsIda`,
	"gap32": `TaskNotificationToasts-module__gap-32___fMDVY`,
	"gap40": `TaskNotificationToasts-module__gap-40___wV2Ly`,
	"gap50": `TaskNotificationToasts-module__gap-50____ab7L`,
	"flex1": `TaskNotificationToasts-module__flex-1___AbwTZ`,
	"flexNone": `TaskNotificationToasts-module__flex-none___exIKL`,
	"flexColumn": `TaskNotificationToasts-module__flex-column___f7EcF`,
	"flexRow": `TaskNotificationToasts-module__flex-row___MGKV4`,
	"verticallyCentered": `TaskNotificationToasts-module__vertically-centered___q8Jw2`,
	"horizontallyCentered": `TaskNotificationToasts-module__horizontally-centered___CY58I`,
	"horizontallyEnd": `TaskNotificationToasts-module__horizontally-end___MwWqG`,
	"verticallyStart": `TaskNotificationToasts-module__vertically-start___YPGOX`,
	"spaceBetween": `TaskNotificationToasts-module__space-between___XwxHo`,
	"flexWrap": `TaskNotificationToasts-module__flex-wrap___Bfxzu`,
	"height100": `TaskNotificationToasts-module__height-100___ipoVk`,
	"width50": `TaskNotificationToasts-module__width-50___CyQYW`,
	"width100": `TaskNotificationToasts-module__width-100____AbNA`,
	"cursorPointer": `TaskNotificationToasts-module__cursor-pointer___AZDss`,
	"cursorNotAllowed": `TaskNotificationToasts-module__cursor-not-allowed___efGME`,
	"absoluteCentered": `TaskNotificationToasts-module__absolute-centered___oNTMN`,
	"absolute": `TaskNotificationToasts-module__absolute___qaZnl`,
	"relative": `TaskNotificationToasts-module__relative___QF7fs`,
	"fixed": `TaskNotificationToasts-module__fixed___HNN3Y`,
	"visible": `TaskNotificationToasts-module__visible___EqcyD`,
	"invisible": `TaskNotificationToasts-module__invisible___kBEK5`,
	"col90": `TaskNotificationToasts-module__col-90___tuU75`,
	"colAuto": `TaskNotificationToasts-module__col-auto___OP0Aj`,
	"medicalTabs": `TaskNotificationToasts-module__medical-tabs___iqnzz`,
	"medicalTableNew": `TaskNotificationToasts-module__medical-table-new___OhIHi`,
	"noPagination": `TaskNotificationToasts-module__no-pagination___oReYU`,
	"medicalTableEmpty": `TaskNotificationToasts-module__medical-table-empty___tBHxc`,
	"iconBtn": `TaskNotificationToasts-module__icon-btn___VvfHc`,
	"searchIcon": `TaskNotificationToasts-module__search-icon___NyRY6`,
	"disableSelect": `TaskNotificationToasts-module__disable-select___JZ5te`,
	"breakWord": `TaskNotificationToasts-module__break-word___mwda0`,
	"popupClearBtn": `TaskNotificationToasts-module__popup-clear-btn___BsjXo`,
	"scrollMB20": `TaskNotificationToasts-module__scroll-m-b-20___j5kkK`,
	"container": `TaskNotificationToasts-module__container___riGRp`,
	"toast": `TaskNotificationToasts-module__toast___Vf9X5`,
	"toastEntering": `TaskNotificationToasts-module__toastEntering___ru_Hq`,
	"slideUp": `TaskNotificationToasts-module__slideUp___t6FbF`,
	"toastLeaving": `TaskNotificationToasts-module__toastLeaving___vJgkM`,
	"slideDown": `TaskNotificationToasts-module__slideDown___D71CN`,
	"toastCritical": `TaskNotificationToasts-module__toastCritical___RFD_9`,
	"toastAssignment": `TaskNotificationToasts-module__toastAssignment___rSsk0`,
	"toastEscalation": `TaskNotificationToasts-module__toastEscalation___fqbzX`,
	"toastFollowedChange": `TaskNotificationToasts-module__toastFollowedChange___RvIeo`,
	"toastOverdue": `TaskNotificationToasts-module__toastOverdue___bcoBF`,
	"toastSubtasksCompleted": `TaskNotificationToasts-module__toastSubtasksCompleted___ruWvI`,
	"toastSubtaskCanceled": `TaskNotificationToasts-module__toastSubtaskCanceled___xgete`,
	"title": `TaskNotificationToasts-module__title___y0Tpw`,
	"closeButton": `TaskNotificationToasts-module__closeButton___yJAgN`,
	"closeIcon": `TaskNotificationToasts-module__closeIcon___d2PDr`
};
module.exports = ___CSS_LOADER_EXPORT___;
